import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid, { GridProps } from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons';

import { colors } from '@picardy/picardy-design-system';

import { getNextLessonCta } from '../../../api/content';
import SectionHeaderBar, {
  Props as SectionHeaderBarProps,
} from '../SectionHeaderBar';
import { RightCardActions } from '../CardExtras';
import '../../../common/components/CourseDetail/index.css';

export interface Props {
  title: string;
  courses: {
    _id: string;
    url: string;
    title: string;
    subtitle: string;
    completed: boolean;
    completedPercentage: number;
    nextLesson?: {
      url: string;
    };
  }[];
  headerVariant?: SectionHeaderBarProps['variant'];
  xs?: GridProps['xs'];
  sm?: GridProps['sm'];
  md?: GridProps['md'];
  lg?: GridProps['lg'];
  xl?: GridProps['xl'];
}

export default function CourseList({
  title,
  courses,
  headerVariant = 'gray',
  xs = undefined,
  sm = 12,
  md = 6,
  lg = undefined,
  xl = undefined,
}: Props) {
  return (
    <>
      <SectionHeaderBar title={title} variant={headerVariant} />
      <Grid
        container
        spacing={2}
        style={{ marginBottom: '2em' }}
        alignItems="stretch"
      >
        {courses.map(course => {
          return (
            <Grid key={course._id} item xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
              <Paper
                elevation={2}
                style={{
                  padding: '1em',
                  height: '100%',
                }}
              >
                <Box display="flex" flexDirection="column" height="100%">
                  <Typography
                    style={{ color: colors.picardyGray, marginBottom: '0.5em' }}
                    variant="h6"
                  >
                    <Link href={course.url}>{course.title}</Link>
                    {course.completed && (
                      <>
                        &nbsp;
                        <FontAwesomeIcon
                          color={colors.picardySuccessGreen}
                          icon={faCheckCircle}
                          aria-label="Completed"
                        />
                      </>
                    )}
                  </Typography>
                  <Typography
                    variant="body1"
                    className="course-subtitle"
                    style={{ flexGrow: 1 }}
                  >
                    <div
                      dangerouslySetInnerHTML={{ __html: course.subtitle }}
                    />
                  </Typography>

                  <RightCardActions
                    style={{
                      padding: 0,
                      margin: 0,
                      marginTop: '2em',
                      flexGrow: 0,
                    }}
                  >
                    <Button
                      style={{ textAlign: 'right', marginBottom: '0.5em' }}
                      size="large"
                      type="button"
                      color="primary"
                      href={course.url}
                    >
                      View All
                    </Button>

                    <Button
                      style={{ textAlign: 'right', marginBottom: '0.5em' }}
                      variant="contained"
                      size="large"
                      type="submit"
                      color="primary"
                      href={
                        course.nextLesson ? course.nextLesson.url : course.url
                      }
                    >
                      {getNextLessonCta(course)}
                    </Button>
                  </RightCardActions>
                </Box>
              </Paper>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
}
